module.exports = __webpack_public_path__ + "img/little-logo.3e8918e1.png";